import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { getWorkWiseAuthToken } from "../utils/helper";
import Loader from "../components/SkeletonLoader/Loader";
import { slideAction } from "../../src/store/slideSlice";
import { useDispatch, useSelector } from "react-redux";
import { workwiseServices } from "../components/WorkW-Api/workWiseApi";
import { getMergedCachedData } from "./documentCache";
import { isEffectivelyOffline } from "./helper";
import { isLocalPresentationRoute } from "./localPresentations";

export const AuthenticateDocument = ({ setIsLoading, background = false }) => {

  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();
  const isTemplateDocument = useSelector((state) => state.slide.isTemplateDocument);

  const handleAuhenticate = async () => {
    try {
      setIsLoading(true);
      // Offline + local presentation: there is no server counterpart, so skip
      // the auth API entirely instead of redirecting to /no-internet.
      if (isEffectivelyOffline() && isLocalPresentationRoute()) {
        setIsLoading(false);
        dispatch(slideAction.setIsAuthenticated(true));
        return;
      }
      if (!window.navigator.onLine) {
        // history.push('/no-internet');
        window.location.pathname = "/no-internet"

        return;
      }
      else {
        if (!!getWorkWiseAuthToken()) {
          const response = await workwiseServices.getDocumentById(id);
          if (response?.status == 200 && response.data?.data?.rightType !== 0 && response.data?.data) {
            setIsLoading(false);
            dispatch(slideAction.setDocumentInformation(response.data.data));
            dispatch(slideAction.setIsAuthenticated(true));
          }
          if (response.data?.data?.rightType == 0) {
            // history.push("/unauthorized")
            window.location.pathname = "/unauthorized"
          }
          // history.push("/unauthorized")
        }
        else {
          // history.push("/unauthorized")
          window.location.pathname = "/unauthorized"
        }
      }
    } catch (error) {
      console.log({ error })
      if (error.response?.data?.responseCode === 1008) {
        if (isTemplateDocument) {
          setIsLoading(false);
          dispatch(slideAction.setIsAuthenticated(true));
          return;
        }
        // history.push("/invalid-document")
        window.location.pathname = "/invalid-document"
      }
      else {
        // history.push("/unauthorized")
        window.location.pathname = "/unauthorized"
      }
    }
  }

  // In background mode, seed documentInfo + auth state from the cache up front so
  // the Header (avatar, members, share) renders fully while the auth API
  // re-validates behind the scenes. A cached entry only exists for a previously
  // authenticated user; if access was since revoked, the API call below redirects.
  useEffect(() => {
    if (background) {
      const merged = getMergedCachedData(id);
      if (merged?.documentInfo) {
        dispatch(slideAction.setDocumentInformation(merged.documentInfo));
        dispatch(slideAction.setIsAuthenticated(true));
      }
    }
  }, [background, id]);

  useEffect(() => {
    if (isTemplateDocument !== null) {
      handleAuhenticate();
    }
  }, [isTemplateDocument]);

  // Background mode renders nothing (no loader) — MainLayout is already on screen.
  if (background) return null;

  return <Loader />
}